var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"additional-info-container"},[(_vm.playlistItem && _vm.playlistItem.display_priority === _vm.DISPLAY_PRIORITY.PRIORITY)?_c('div',{staticClass:"priority-indicator"},[_vm._v(" PRIO ")]):(_vm.playlistItem && _vm.playlistItem.display_priority === _vm.DISPLAY_PRIORITY.FALLBACK)?_c('div',[_c('img',{attrs:{"src":require("@/assets/icon/fallback.svg"),"alt":"Fallback","title":"Fallback"}})]):_vm._e(),(
      _vm.playlistItem &&
      _vm.playlistItem.scheduler &&
      _vm.playlistItem.scheduler.available !== _vm.SCHEDULE_TYPES.ALWAYS
    )?_c('div',{staticClass:"schedule-indicator",attrs:{"title":"Scheduled"}}):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }